import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

/**
 * Hook responsible to call cleanup callback on queries when they're removed from cache
 * Example: disconnect Mqtt connections
 */
export const useObserveQueryCache = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const queryCache = queryClient.getQueryCache();

    const unsubscribe = queryCache.subscribe(({ query, type }) => {
      const { meta, state, queryKey } = query;
      if (type === 'removed' && typeof meta?.onRemoveFromCache === 'function') {
        meta.onRemoveFromCache(state, queryKey);
      }
    });

    return () => unsubscribe();
  }, [queryClient]);
};
